import {
  ChangeDetectionStrategy,
  Component,
  input,
  signal
} from "@angular/core";
import { FormGroup, ReactiveFormsModule } from "@angular/forms";
import { TranslateModule } from "@ngx-translate/core";
import { MatRadioGroup } from "@angular/material/radio";
import {
  InsuranceCompanyResponse,
  PackageResponse,
  PackageTypeEnum,
  WorkshopSystemEnum
} from "src/domain/client";
import { IViewPair } from "src/app/interfaces/interfaces";
import { FormService } from "src/app/services/form.service";
import { IconService } from "src/app/services/icon.service";
import { SectionTogglerComponent } from "../../layout/section-toggler/section-toggler.component";
import { WindscreenWizardComponent } from "../../layout/windscreen-wizard/windscreen-wizard.component";
import { PackagesFilterPipe } from "src/app/pipes/packages-filter.pipe";

@Component({
  selector: "app-specs-windscreen-section",
  templateUrl: "./specs-windscreen-section.component.html",
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    SectionTogglerComponent,
    ReactiveFormsModule,
    MatRadioGroup,
    WindscreenWizardComponent,
    TranslateModule,
    PackagesFilterPipe
  ]
})
export class SpecsWindscreenSectionComponent {
  packages = input.required<PackageResponse[]>();
  insuranceProviders = input<InsuranceCompanyResponse[] | null>(null);
  insuranceViewPairs = input<IViewPair[]>([]);

  toggle = signal(false);
  WorkshopSystemEnum = WorkshopSystemEnum;
  PackageTypeEnum = PackageTypeEnum;

  constructor(
    public formService: FormService,
    public iconService: IconService
  ) {}

  get form(): FormGroup {
    return this.formService.chooseSpecificationsForm.controls
      .windscreenForm as FormGroup;
  }
}
